export const FINAL_WEIGHT_EXCEEDS_DRY_WEIGHT =
  "Instance of 'YieldExceedsDryWeightException'";
